import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card'
import { FieldError } from '@/shared/components/ui/field-error'
import { Input } from '@/shared/components/ui/input'
import { Label } from '@/shared/components/ui/label'
import { cn } from '@/shared/lib/utils'

export default function QuotationDetailsCard({
  form,
  errors = {},
  onChange,
  isLeadSelected = false,
}) {
  const fieldClass = (key) =>
    cn(errors[key] && 'border-red-500 focus-visible:ring-red-500')

  const lockedFieldClass =
    'bg-slate-100/80 font-medium text-slate-600 cursor-not-allowed select-none focus-visible:ring-0 focus-visible:border-slate-200'

  return (
    <Card>
      <CardHeader>
        <CardTitle>Quotation Details</CardTitle>
      </CardHeader>

      <CardContent className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div className="w-full space-y-2">
          <div className="flex items-center justify-between">
            <Label>Quote No</Label>
            <span className="text-[11px] font-medium text-slate-400">
              Auto-generated
            </span>
          </div>

          <Input
            value={form.quoteNo}
            readOnly
            tabIndex={-1}
            aria-invalid={Boolean(errors.quoteNo)}
            data-invalid={errors.quoteNo ? 'true' : undefined}
            className={cn(
              fieldClass('quoteNo'),
              'bg-slate-100/80 font-mono text-slate-600 cursor-not-allowed select-none focus-visible:ring-0 focus-visible:border-slate-200',
            )}
          />

          <FieldError message={errors.quoteNo} />
        </div>

        <div className="w-full space-y-2">
          <div className="flex items-center justify-between">
            <Label>Contact Name</Label>

            {isLeadSelected && (
              <span className="text-[11px] font-medium text-slate-400">
                From Lead
              </span>
            )}
          </div>

          <Input
            value={form.contactName}
            readOnly={isLeadSelected}
            tabIndex={isLeadSelected ? -1 : undefined}
            onChange={
              isLeadSelected
                ? undefined
                : (e) => onChange('contactName', e.target.value)
            }
            aria-invalid={Boolean(errors.contactName)}
            data-invalid={errors.contactName ? 'true' : undefined}
            className={cn(
              fieldClass('contactName'),
              isLeadSelected && lockedFieldClass,
            )}
          />

          <FieldError message={errors.contactName} />
        </div>

        <div className="w-full space-y-2">
          <div className="flex items-center justify-between">
            <Label>Account Name</Label>

            {isLeadSelected && (
              <span className="text-[11px] font-medium text-slate-400">
                From Lead
              </span>
            )}
          </div>

          <Input
            value={form.accountName}
            readOnly={isLeadSelected}
            tabIndex={isLeadSelected ? -1 : undefined}
            onChange={
              isLeadSelected
                ? undefined
                : (e) => onChange('accountName', e.target.value)
            }
            aria-invalid={Boolean(errors.accountName)}
            data-invalid={errors.accountName ? 'true' : undefined}
            className={cn(
              fieldClass('accountName'),
              isLeadSelected && lockedFieldClass,
            )}
          />

          <FieldError message={errors.accountName} />
        </div>

        <div className="w-full space-y-2">
          <Label>Quote Date</Label>

          <Input
            type="datetime-local"
            value={form.quoteDate}
            onChange={(e) => onChange('quoteDate', e.target.value)}
            aria-invalid={Boolean(errors.quoteDate)}
            data-invalid={errors.quoteDate ? 'true' : undefined}
            className={fieldClass('quoteDate')}
          />

          <FieldError message={errors.quoteDate} />
        </div>

        <div className="w-full space-y-2">
          <Label>
            Valid Until
            <span className="ml-1 text-xs text-muted-foreground">
              (Optional)
            </span>
          </Label>

          <Input
            type="date"
            value={form.validUntil}
            onChange={(e) => onChange('validUntil', e.target.value)}
            aria-invalid={Boolean(errors.validUntil)}
            data-invalid={errors.validUntil ? 'true' : undefined}
            className={fieldClass('validUntil')}
          />

          <FieldError message={errors.validUntil} />
        </div>
      </CardContent>
    </Card>
  )
}
